export const TOOLTIP_OFFSET = -250;
export const TOOLTIP_POSITION = { x: -160, y: -3 };
export const TOOLTIP_THREE_DAYS_POSITION = { x: undefined, y: -3 };
